import React, { Component } from 'react';
import withRouter from '../../services/withRouter';
import { connect } from "react-redux";
import './watch.scss';
import { showLoader, hideLoader } from "../../action/application";
import ApiServices from '../../services/apiServices';
import CryptoJS from 'crypto-js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import axios from 'axios';

class Watch extends Component {
  player;
  playStartTime = null;
  totalWatchTime = 0;
  wasPlayingBeforeHidden = false;

  constructor(props) {
    super(props);
    this.state = {
      videoData: {},
      skipIntro: false,
      loader: false,
      resume: 0,
      userEmail: localStorage.getItem('usermail') || '',
      previousPosition: 0
    };
    this.videoContainerRef = React.createRef();
    this.userInfo = null;
  }

  safeStringify(obj) {
    try {
      // include non-enumerable props from Error objects
      return JSON.stringify(obj, Object.getOwnPropertyNames(obj), 2);
    } catch (e) {
      try { return String(obj); } catch (e2) { return '<<unserializable>>'; }
    }
  }


  componentDidMount() {
    // Show loader and restore decrypted user info before other mount work
    this.props.dispatch(showLoader());

    if (localStorage.getItem('userKey')) {
      try {
        const bytes = CryptoJS.AES.decrypt(localStorage.getItem('userKey'), process.env.REACT_APP_SECERET_KEY);
        this.userInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } catch (e) {
        console.error('Failed to decrypt userKey', e);
      }
    }

    this.props.dispatch(hideLoader());

    const { flimId, episodeId } = this.props.params;
    this.setState({
      videoData: {},
      skipIntro: false,
      loader: true
    }, () => {
      this.getVideoContent(flimId, episodeId);
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    this.cleanupPlayer();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleBeforeUnload = () => {
    if (this.player) {
      this.stop_video();
    }
  };

  handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      if (this.player && !this.player.paused) {
        this.player.pause();
        this.wasPlayingBeforeHidden = true;

        if (this.playStartTime) {
          const currentTime = Date.now();
          const watchTime = (currentTime - this.playStartTime);
          this.totalWatchTime += watchTime;
          this.playStartTime = null;
        }
      }
    } else if (document.visibilityState === 'visible') {
      if (this.player && this.wasPlayingBeforeHidden) {
        this.player.play().catch(err => {
          console.log('Auto-play prevented:', err);
        });
        this.wasPlayingBeforeHidden = false;

        this.playStartTime = Date.now();
      }
    }
  };

  getResume() {
    const { flimId, episodeId, type } = this.props.params;
    const url = `movie/tv/resume/${flimId}/${episodeId ? episodeId : ''}`;
    ApiServices.callGetAPI(url).then(data => {
      if (data.status === 200 && data.data.valid) {
        this.setState({
          resume: type === "promo" ? 0 : data.data.data
        });
      }
    }).catch(error => {
      console.log(error);
    });
  }

  setPlayerConfig(videoInfo) {
    this.getResume();
    const { type } = this.props.params;
    const watchUrl = type === 'promo' ? videoInfo.trailerUrl : videoInfo.videoUrl;

    console.log('setPlayerConfig watchUrl:', watchUrl, 'userAgent:', navigator.userAgent);

    const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    if (isIOS) {
      const vidEl = document.getElementById('player');
      if (vidEl) {
        // Use native HLS on iOS Safari — set src on the video element directly
        try {
          vidEl.src = watchUrl;
          vidEl.type = 'application/vnd.apple.mpegurl';
        } catch (e) {
          console.error('Error setting native iOS video src', e);
        }
      }
    }

    // Configure Plyr with iOS-specific settings
    this.player = new window.Plyr('#player', {
      debug: false,
      autoplay: true,
      muted: true, // start muted to allow autoplay in browsers that require it
      title: videoInfo.title,
      iconUrl: 'https://d12it2ctp7su6p.cloudfront.net/shortflix-web-static/image/plyr.svg',
      keyboard: {
        global: true,
      },
      invertTime: false,
      storage: { enabled: false, key: 'plyr' },
      controls: [
        'play-large',
        'restart',
        'rewind',
        'play',
        'fast-forward',
        'progress',
        'duration',
        'current-time',
        'mute',
        'volume',
        'seasons',
        'captions',
        'settings',
        'fullscreen',
      ],
      settings: ['quality'],
      tooltips: {
        controls: true,
      },
      captions: {
        active: true,
        update: true,
      },
      // iOS-specific fullscreen configuration
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true // Use native iOS fullscreen
      },
      // HLS configuration
      hls: {
        // disable plyr/hls.js on iOS so native HLS is used there
        enabled: !isIOS,
        src: watchUrl
      }
    });

    // Attempt to play automatically after initialization
    this.player.on('ready', () => {
      // Plyr ready handler above will also run; attempt play for non-iOS
      if (!isIOS) {
        this.player.play().catch(err => {
          console.log('Autoplay prevented or failed:', err);
        });
      }
    });

    // Handle iOS autoplay - unmute after playback starts
    this.player.on('playing', () => {
      if (this.player.muted) {
        // Try to unmute after video starts playing on iOS
        setTimeout(() => {
          this.player.muted = false;
        }, 100);
      }
    });

    this.player.on('play', () => {
      this.playStartTime = Date.now();
      console.log('Video playing');
      this.play_video();
    });

    this.player.on('ended', () => {
      console.log('Video ended');
      this.ended_video();
    });

    this.player.on('pause', this.handlePauseEvent);

    this.player.on('timeupdate', () => {
      if (this.player && this.state.previousPosition !== this.player.currentTime) {
        this.setState({
          previousPosition: this.player.currentTime
        });
      }

      if (!this.playStartTime && this.player && !this.player.paused) {
        this.playStartTime = Date.now();
      }
    });

    this.player.on('loadeddata', () => {
      if (this.player) {
        this.player.currentTime = Number(this.state.resume) || 0;
      }
    });

    // Additional iOS-specific handling
    this.player.on('ready', () => {
      if (this.player && this.player.media) {
        this.player.media.setAttribute('playsinline', 'true');
        this.player.media.setAttribute('webkit-playsinline', 'true');

        // iOS SAFETY: require tap
        this.player.media.addEventListener('click', () => {
          if (this.player.paused) {
            this.player.play().catch(() => { });
          }
        });
      }
    });




  }

  handlePauseEvent = () => {
    if (this.playStartTime) {
      const currentTime = Date.now();
      const watchTime = (currentTime - this.playStartTime);
      this.totalWatchTime += watchTime;

      this.playStartTime = null;
      console.log('Video paused');

      console.log(`Previous position: ${this.state.previousPosition}`);
      console.log(`Current position: ${this.player?.currentTime}`);

      this.pauser();
    }
  };

  async play_video() {
    if (!this.player) return;

    const { type } = this.props.params;
    const user = firebase.auth().currentUser;
    if (!user || !user.getIdToken) return;

    try {
      const idToken = await user.getIdToken();
      console.log('Sending play event API...');
      await axios.put(`${process.env.REACT_APP_API_URL}activity/play_video`,
        {
          filmid: this.state.videoData.filmid,
          episodeid: type === 'series' ? ('short' + this.state.videoData.sequence) : '',
          position: this.player?.currentTime || 0,
          completed: 0,
          watchhours: this.totalWatchTime
        },
        {
          headers: {
            'apikey': process.env.REACT_APP_API_KEY,
            'authorization': idToken
          }
        });
    } catch (error) {
      console.error('Error sending play event:', error);
      if (error.response) {
        console.error('Play event response status:', error.response.status, 'data:', error.response.data);
      } else if (error.request) {
        console.error('Play event no response, request:', error.request);
      } else {
        console.error('Play event error message:', error.message);
      }
      console.error('Play event error (axios):', this.safeStringify(error));
    }
  }

  async ended_video() {
    if (!this.player) return;

    const { type } = this.props.params;
    const user = firebase.auth().currentUser;
    if (!user || !user.getIdToken) return;

    try {
      const idToken = await user.getIdToken();
      console.log('Sending ended event API...');
      await axios.put(`${process.env.REACT_APP_API_URL}activity/completion`,
        {
          filmid: this.state.videoData.filmid,
          episodeid: type === 'series' ? ('short' + this.state.videoData.sequence) : '',
          position: this.player?.currentTime || 0,
          completed: 1,
          watchhours: this.totalWatchTime
        },
        {
          headers: {
            'apikey': process.env.REACT_APP_API_KEY,
            'authorization': idToken
          }
        });
    } catch (error) {
      console.error('Error sending ended event:', error);
      if (error.response) {
        console.error('Ended event response status:', error.response.status, 'data:', error.response.data);
      } else if (error.request) {
        console.error('Ended event no response, request:', error.request);
      } else {
        console.error('Ended event error message:', error.message);
      }
      console.error('Ended event error (axios):', this.safeStringify(error));
    }
  }

  async stop_video() {
    if (!this.player) return;

    const { type } = this.props.params;
    const user = firebase.auth().currentUser;
    if (!user || !user.getIdToken) return;

    try {
      const idToken = await user.getIdToken();
      console.log('Sending stop event API...');
      await axios.put(`${process.env.REACT_APP_API_URL}activity/stop_video`,
        {
          filmid: this.state.videoData.filmid,
          episodeid: type === 'series' ? ('short' + this.state.videoData.sequence) : '',
          position: this.player?.currentTime || 0,
          completed: 0,
          watchhours: this.totalWatchTime
        },
        {
          headers: {
            'apikey': process.env.REACT_APP_API_KEY,
            'authorization': idToken
          }
        });
    } catch (error) {
      console.error('Error sending stop event:', error);
      if (error.response) {
        console.error('Stop event response status:', error.response.status, 'data:', error.response.data);
      } else if (error.request) {
        console.error('Stop event no response, request:', error.request);
      } else {
        console.error('Stop event error message:', error.message);
      }
      console.error('Stop event error (axios):', this.safeStringify(error));
    }
  }

  async pauser() {
    if (!this.player) return;

    const { type } = this.props.params;
    const user = firebase.auth().currentUser;
    if (!user || !user.getIdToken) return;

    try {
      const idToken = await user.getIdToken();
      console.log('Sending pause event API...');
      await axios.put(`${process.env.REACT_APP_API_URL}activity/pause_video`,
        {
          filmid: this.state.videoData.filmid,
          episodeid: type === 'series' ? ('short' + this.state.videoData.sequence) : '',
          position: this.state.previousPosition || 0,
          completed: 0,
          watchhours: this.totalWatchTime
        },
        {
          headers: {
            'apikey': process.env.REACT_APP_API_KEY,
            'authorization': idToken
          }
        });
    } catch (error) {
      console.error('Error sending pause event:', error);
      if (error.response) {
        console.error('Pause event response status:', error.response.status, 'data:', error.response.data);
      } else if (error.request) {
        console.error('Pause event no response, request:', error.request);
      } else {
        console.error('Pause event error message:', error.message);
      }
      console.error('Pause event error (axios):', this.safeStringify(error));
    }
  }

  cleanupPlayer() {
    if (this.player) {
      try {
        if (!this.player.paused) {
          this.player.pause();
        }
        this.player.destroy();
        this.player = null;
      } catch (error) {
        console.error('Error cleaning up player:', error);
      }
    }
  }

  goBack() {
    if (this.player) {
      this.stop_video();
    }
    this.cleanupPlayer();
    window.history.back();
  }

  async updateWatchedDuration() {
    if (!this.player) return;

    const { type } = this.props.params;
    const position = this.player.currentTime ? Math.round(this.player.currentTime) : 0;
    const completed = this.player.ended === true ? 1 : 0;

    try {
      await ApiServices.callPutAPI(`${process.env.REACT_APP_API_URL}activity/stop_video`, {
        position: position,
        episodeid: type === 'series' ? ('short' + this.state.videoData.sequence) : '',
        filmid: this.state.videoData.filmid,
        completed: completed
      });
    } catch (error) {
      console.error('Error updating watched duration:', error);
    }
  }

  getVideoContent(flimId, episodeId = null) {
    const url = episodeId ? `movie/tv/${flimId}/episodes` : `movie/tv/${flimId}`;
    ApiServices.callGetAPI(url).then(result => {
      if (result.status === 200 && result.data.valid) {
        if (result.data.data) {
          let epIndex = 0;
          for (let i = 0; i < result.data.data.length; i++) {
            if (result.data.data[i].episodeid === episodeId) {
              epIndex = i;
            }
          }
          const videoInfo = episodeId ? result.data.data[epIndex] : result.data.data;
          this.setState({
            videoData: videoInfo,
            skipIntro: false,
            loader: false
          }, () => {
            this.setPlayerConfig(videoInfo);
          });
        }
      }
    }).catch(error => {
      console.log(error);
    });
  }

  skipIntro() {
    if (this.player) {
      this.player.currentTime = Number(this.state.videoData.skipend);
    }
  }

  render() {
    return (
      <>
        <div className='vp'>
          <h1 className="video-page-title"><center>{this.state.videoData.title}</center></h1>
          {!this.state.loader ?
            <div ref={this.videoContainerRef} className="video-plyr">
              <video
                id="player"
                playsInline
                webkitPlaysInline
                muted
                autoPlay
                controls
                className="player-video"
                poster={this.state.videoData.poster || ''}
              />
              <div className="video-player-overlay">
                <span className='close-icon-video' onClick={() => this.goBack()}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                    <path d="m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z" />
                  </svg>
                </span>
                <div className="video-title-top-center">
                  <div className="player-title-detail">
                    <h2>{this.state.videoData.title}</h2>
                  </div>
                </div>
                {this.state.skipIntro && (
                  <span className='skip-intro' onClick={() => this.skipIntro()}>
                    Skip Intro
                  </span>
                )}
              </div>
            </div>
            : ''}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.application.loading,
  videoInfo: state.application.videoInfo,
  PreviousUrl: state.application.PreviousUrl
});

export default withRouter(connect(mapStateToProps)(Watch));
